// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__tZooT","table":"Table_table__2OuB7","emptyMessage":"Table_emptyMessage__1i0Xv","sortIcons":"Table_sortIcons__1kTAQ"};